import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'

export default class OrderRequest extends BaseModelRequest {

  getModelName () {
    return 'orders'
  }

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();

    return headers;
  }

  orderItem(data) {
    const url = "item/order";
    return this.post(url, data);
  }

  orderCourse(data) {
    const url = "course/order";
    return this.post(url, data);
  }

  vtcPay(data) {
    const url = "payment/tmdt/vtc";
    return this.post(url, data);
  }

  viettelPayCourse(data) {
    const url = "payment/tmdt/vtc";
    return this.post(url, data);
  }

  verifyPromo(promo_code) {
    const url = `promo/${promo_code}`;
    return this.post(url, '');
  }

  updateStateForVTC (data) {
    const url = 'vtc/payment/update'
    return this.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/request/OrderRequest.js